module.exports = __webpack_public_path__ + "img/Acordeon.07bd90f2.svg";